import { Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import moment from "moment";
import VoucherCreateTable from "./VoucherCreateTable";




function VoucherCorporateContent(props) {
    const { voucherDetails, newVoucherList } = props;
    const [summary, setSummary] = useState({total:0, assigned:0, open:0, un_assigned:0 , redeemed: 0});



    useEffect(()=> {
        
        let un_assigned = 0;
        let redeemed = 0;
        let open = 0;
        let total = newVoucherList.length;
        newVoucherList.forEach(element => {
            if(element?.Voucher_Status_Id === 3){
                un_assigned += 1;
            }
            if(element?.Voucher_Status_Id === 2){
                redeemed += 1;
            }
            if(element?.Voucher_Status_Id === 1){
                open += 1;
            }
            
        });

        setSummary({un_assigned: un_assigned, open: open, redeemed: redeemed, total: total});
    },[newVoucherList]);


    //  dynamically manage different status
    const manageSalesStatus = (status) => {
        let defaultClass = 'status_color1 text-white';

        switch (status) {
            case 'Draft':
                defaultClass = 'text-light status_color2';
                break;
            case 'Approved':
                defaultClass = 'text-light status_color3';
                break;
            case 'Pending for Approval':
                defaultClass = 'text-dark status_color4';
                break;
            case 'Fulfilled':
                defaultClass = 'text-light status_color5';
                break;
            case 'Rejected':
                defaultClass = 'text-light status_color6';
                break;
            case 'Confirmed':
                defaultClass = 'text-light status_color1';
                break;
            case 'Partially Billed':
                defaultClass = 'text-light status_color8';
                break;

            default:
                break;
        }

        return (
            <span className={`py-2 pl-4 pr-4 pt-2 pb-2 h5 ${defaultClass} rounded`}>
                {status}
            </span>
        );
    };


    // view subscription by going to subscription module




    return (
        <section className="mt-4 w-full max-w-6xl text-gray-700">
        <div className="border-2 border-gray-200 rounded-lg mx-4 my-2 bg-gray-50 p-6">
          <div className="flex flex-col md:flex-row gap-6">
            <div className="md:w-1/2">
              <div className="space-y-3">
                <div className="flex justify-between items-center">
                  <span className="text-md font-medium">Corporate Name:</span>
                  <span className="text-lg font-bold text-blue-600">{voucherDetails?.Corporate_Name}</span>
                </div>
                <div className="flex justify-between items-center">
                  <span className="text-md font-medium">Address:</span>
                  <span className="text-md text-gray-500">{voucherDetails?.Address || 'N/A'}</span>
                </div>
                <div className="flex justify-between items-center">
                  <span className="text-md font-medium">Registration Date:</span>
                  <span className="text-md text-gray-500">{voucherDetails?.Registration_Date ? moment(voucherDetails?.Registration_Date).format('DD/MM/YYYY') : 'N/A'}</span>
                </div>
                <div className="flex justify-between items-center">
                  <span className="text-md font-medium">Contact Person:</span>
                  <span className="text-md text-gray-500">{voucherDetails?.Contact_Person || 'N/A'}</span>
                </div>
                <div className="flex justify-between items-center">
                  <span className="text-md font-medium">Created By:</span>
                  <span className="text-md text-gray-500">{voucherDetails?.Created_By || 'N/A'}</span>
                </div>
                <div className="flex items-start">
                  <span className="text-md font-medium">Note:</span>
                  <span className="text-md text-gray-500 ml-2">{voucherDetails?.Voucher_Remark || 'N/A'}</span>
                </div>
              </div>
            </div>
            <div className="md:w-1/2">
              <div className="space-y-3">
                <div className="flex justify-between items-center">
                  <span className="text-md font-medium">Voucher Quantity:</span>
                  <span className="text-md text-gray-500">{voucherDetails?.Voucher_Quantity || 0}</span>
                </div>
                <div className="flex justify-between items-center">
                  <span className="text-md font-medium">Amount/Unit:</span>
                  <span className="text-md text-gray-500">₦{(voucherDetails?.Voucher_Amount || 0).toLocaleString()}</span>
                </div>
                <div className="flex justify-between items-center">
                  <span className="text-md font-medium">Total Amount:</span>
                  <span className="text-md text-gray-500">₦{(voucherDetails?.Total_Voucher_Amount || 0).toLocaleString()}</span>
                </div>
                <div className="flex justify-between items-center">
                  <span className="text-md font-medium">Created Date:</span>
                  <span className="text-md text-gray-500">{voucherDetails?.Voucher_Date ? moment(voucherDetails?.Voucher_Date).format('llll') : 'N/A'}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="border-2 border-gray-200 rounded-lg mx-4 my-2 bg-gray-50 p-6">
          <div className="mb-4">
            <span className="text-lg font-bold text-blue-700">Voucher Information</span>
          </div>
          <div>
            <VoucherCreateTable shareActionButtonAll={props?.shareActionButtonAll} />
          </div>
        </div>
      </section>
    );
}

export default VoucherCorporateContent;
